import { GtmService } from '@omnia/ui'
import { sendNewAccountDataLayer } from '@/common/services/gtm/custom/new-account.gtm'
import { sendUserProperties } from '@/common/services/gtm/custom/user-properties.gtm'
import { EventsGtmEvents } from '@/common/services/gtm/eccommerce/events.gtm'
import { FilmsGtmEvents } from '@/common/services/gtm/eccommerce/films.gtm'
import { GiftShopGtmEvents } from '@/common/services/gtm/eccommerce/gift-shop.gtm'
import { SubscriptionsGtmEvents } from '@/common/services/gtm/eccommerce/subscriptions.gtm'
import { TicketBundlesGtmEvents } from '@/common/services/gtm/eccommerce/ticket-bundles.gtm'
import { TicketingGtmEvents } from '@/common/services/gtm/eccommerce/ticketing.gtm'
import type { CurzonEcommerceDataLayer } from '@/common/services/models-gtm'
import { getMembershipTier } from '@/common/utils/getMembershipTier'

class CurzonGtmService extends GtmService {
    constructor() {
        super()
    }
    public async sendEcommerceDataLayer(dataLayerObj: CurzonEcommerceDataLayer) {
        dataLayerObj.membership_tier = (await getMembershipTier()) ?? 'None'
        super.sendDataLayer(dataLayerObj)
    }
    public ecommerce = {
        events: EventsGtmEvents,
        films: FilmsGtmEvents,
        subscriptions: SubscriptionsGtmEvents,
        giftShop: GiftShopGtmEvents,
        ticketBundles: TicketBundlesGtmEvents,
        ticketing: TicketingGtmEvents,
    }

    public customEvents = {
        newAccount: sendNewAccountDataLayer,
        userPropertiesUpdate: sendUserProperties,
    }
}

export const gtm = new CurzonGtmService()
